import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/team-area/superhero-icon.svg'
import _imports_1 from '../../assets/team-area/dashboard-icon.svg'
import _imports_2 from '../../assets/team-area/grow-leaves-icon.svg'
import _imports_3 from '../../assets/team-area/jyranian-superhero-cropped.png'
import _imports_4 from '../../assets/team-area/jyranian-superhero-cropped-2.png'
import _imports_5 from '../../assets/wave-emoji.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-67de1836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-tabs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Team Lead icon"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "Team Lead Area", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Team Dashboard icon"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "Team Dashboard", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "My Development icon"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "My Development", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "My Dashboard icon"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-text" }, "My Dashboard", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "primary-header-content-container" }
const _hoisted_15 = { class: "header-section-left" }
const _hoisted_16 = { "data-test": "team-lead-description" }
const _hoisted_17 = { class: "header-section-right" }
const _hoisted_18 = {
  key: 0,
  src: _imports_3,
  alt: "Team Lead Superhero Male",
  "data-test": "hero-image"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_4,
  alt: "Team Lead Superhero Female",
  "data-test": "hero-image"
}
const _hoisted_20 = {
  key: 0,
  href: "/teamgoals",
  class: "btn btn-team-goals btn-thin team-goals-button",
  "data-test": "goals-document-link"
}
const _hoisted_21 = {
  key: 1,
  class: "header-content",
  "data-test": "team-dashboard-header"
}
const _hoisted_22 = { class: "primary-header-content-container" }
const _hoisted_23 = { class: "header-section-left" }
const _hoisted_24 = {
  class: "header-section-team-info",
  "data-test": "team-name"
}
const _hoisted_25 = { class: "header-section-left" }
const _hoisted_26 = { "data-test": "team-name-heading" }
const _hoisted_27 = {
  key: 0,
  class: "no-team-subtitle"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "header-section-right" }
const _hoisted_30 = {
  class: "guidance-icon-container",
  id: "team-tooltip-target"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 0,
  href: "/teamgoals",
  class: "btn btn-team-goals btn-thin team-goals-button",
  style: {"margin-top":"0"},
  "data-test": "goals-document-link"
}
const _hoisted_33 = {
  key: 2,
  class: "header-content",
  "data-test": "my-dashboard-header"
}
const _hoisted_34 = { class: "primary-header-content-container" }
const _hoisted_35 = { class: "header-section-left" }
const _hoisted_36 = {
  class: "header-section-team-info",
  "data-test": "team-name"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "wave-emoji",
  alt: "wave emoji",
  "data-test": "wave-emoji"
}, null, -1))
const _hoisted_38 = { class: "header-section-right" }
const _hoisted_39 = {
  class: "guidance-icon-container",
  id: "personal-tooltip-target"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/resources/read/manual-of-me",
  class: "btn btn-team-goals btn-thin team-goals-button",
  style: {"margin-top":"0"},
  "data-test": "manual-of-me-document-link"
}, "Manual of Me ", -1))
const _hoisted_41 = {
  key: 3,
  class: "header-content",
  "data-test": "my-development-header"
}
const _hoisted_42 = { class: "primary-header-content-container" }
const _hoisted_43 = { class: "header-section-left" }
const _hoisted_44 = {
  class: "header-section-team-info",
  "data-test": "user-name"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "wave-emoji",
  alt: "wave emoji",
  "data-test": "wave-emoji"
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/resources/read/manual-of-me",
  class: "btn btn-team-goals btn-thin team-goals-button",
  style: {"margin-top":"0"},
  "data-test": "manual-of-me-document-link"
}, "Manual of Me ", -1))

import { Ref, computed, inject, ref, watch } from "vue";
import GuidanceButton from "../guidance-button.vue";
import { HomeView } from "../../views/home-page.vue";
import localStorageService from "../../services/utilities/local-storage-service";
import { TeamApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";

type HeroGender = "male" | "female";


export default /*#__PURE__*/_defineComponent({
  __name: 'header-with-tabs',
  props: {
    currentTab: {}
  },
  emits: ["update:selectedView"],
  setup(__props: any, { emit: __emit }) {

const teamModel = inject("teamModel") as Ref<TeamApiModel>;
const isTeamGoalsSet = inject("isTeamGoalsSet") as Ref<boolean>;

const emit = __emit;

const props = __props;

const firstName = computed(() => csContext.user.firstName);

const userIsTeamLeader = inject("userIsTeamLeader") as Ref<boolean>;

const heroGender = ref<HeroGender>(localStorageService.get<HeroGender>("heroGender") ?? "male");

const subTitleText = computed(() => {
  return userIsTeamLeader.value
    ? "You're in the right place to develop your team."
    : "You need to set up a team to unlock this area.";
});

function switchHeroGender() {
  heroGender.value = heroGender.value === "male" ? "female" : "male";
}

watch(heroGender, () => {
  localStorageService.save("heroGender", heroGender.value);
});

const teamImageUrl = computed(() => {
  if (teamModel.value?.id) {
    return (
      localStorageService.get<string>(`teamImageUrl-${teamModel.value.id}`) ??
      teamModel.value?.imageUrl
    );
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["team-area-header container maxWidth-md", {
      'team-lead-header': props.currentTab === 'TeamLeadArea',
      'team-dashboard-header': props.currentTab === 'TeamDashboard',
      'my-dashboard-header': props.currentTab === 'MyDashboard',
      'my-development-header': props.currentTab === 'MyDevelopment',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["team-lead-tab", { 'locked-levels-tab': !_unref(userIsTeamLeader) }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:selectedView', 'TeamLeadArea'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('update:selectedView', 'TeamLeadArea')), ["space"])),
        "data-test": "team-lead-tab",
        tabindex: "0"
      }, _hoisted_4, 34),
      _createElementVNode("div", {
        class: "dashboard-tab",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:selectedView', 'TeamDashboard'))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (emit('update:selectedView', 'TeamDashboard')), ["space"])),
        "data-test": "team-dashboard-tab",
        tabindex: "0"
      }, _hoisted_7, 32),
      _createElementVNode("div", {
        class: "my-development-tab",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('update:selectedView', 'MyDevelopment'))),
        onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (emit('update:selectedView', 'MyDevelopment')), ["space"])),
        "data-test": "my-development-tab",
        tabindex: "0"
      }, _hoisted_10, 32),
      _createElementVNode("div", {
        class: "my-dashboard-tab",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('update:selectedView', 'MyDashboard'))),
        onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (emit('update:selectedView', 'MyDashboard')), ["space"])),
        "data-test": "my-dashboard-tab",
        tabindex: "0"
      }, _hoisted_13, 32)
    ]),
    (props.currentTab === 'TeamLeadArea')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["header-content", { 'locked-levels': !_unref(userIsTeamLeader) }]),
          "data-test": "team-lead-header"
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h1", null, "Hello, " + _toDisplayString(_unref(userIsTeamLeader) ? "Team Lead" : firstName.value), 1),
              _createElementVNode("p", _hoisted_16, _toDisplayString(subTitleText.value), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (heroGender.value === 'male')
                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                : (_openBlock(), _createElementBlock("img", _hoisted_19)),
              _createElementVNode("button", {
                type: "button",
                onClick: switchHeroGender,
                class: "btn btn-switch",
                "data-test": "hero-image-switch"
              })
            ])
          ]),
          (_unref(isTeamGoalsSet))
            ? (_openBlock(), _createElementBlock("a", _hoisted_20, "Team Goals "))
            : _createCommentVNode("", true)
        ], 2))
      : (props.currentTab === 'TeamDashboard')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h1", _hoisted_26, _toDisplayString(_unref(teamModel) ? _unref(teamModel).name : "Setup a team"), 1),
                    (!_unref(teamModel))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Unlock your Team Dashboard where you'll have access to a Team Solo report, Team Viewpoints report, team outcomes and much more. "))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(teamModel))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: teamImageUrl.value,
                        alt: "Team Logo",
                        class: "team-image-container team-image-container-md",
                        "data-test": "team-image"
                      }, null, 8, _hoisted_28))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(GuidanceButton, {
                    link: "/resources/read/using-gyre-as-a-team-member",
                    "tooltip-text": "How to get the most from my Team Journey",
                    "tooltip-target": "#team-tooltip-target",
                    "img-width": "43px"
                  })
                ]),
                (_unref(teamModel))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: '/team/settings/' + _unref(teamModel).id,
                      class: "btn btn-default-settings",
                      "aria-label": "team settings",
                      "data-test": "settings-button"
                    }, null, 8, _hoisted_31))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(isTeamGoalsSet))
              ? (_openBlock(), _createElementBlock("a", _hoisted_32, "Team Goals "))
              : _createCommentVNode("", true)
          ]))
        : (props.currentTab === 'MyDashboard')
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h1", null, [
                      _createTextVNode(" Hello, " + _toDisplayString(firstName.value) + " ", 1),
                      _hoisted_37
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(GuidanceButton, {
                      link: "/resources/read/using-gyre-as-an-individual",
                      "tooltip-text": "How to get the most from my Personal Journey",
                      "tooltip-target": "#personal-tooltip-target",
                      "img-width": "43px"
                    })
                  ])
                ])
              ]),
              _hoisted_40
            ]))
          : (props.currentTab === 'MyDevelopment')
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h1", null, [
                        _createTextVNode(" Hello, " + _toDisplayString(firstName.value) + " ", 1),
                        _hoisted_45
                      ])
                    ])
                  ])
                ]),
                _hoisted_46
              ]))
            : _createCommentVNode("", true)
  ], 2))
}
}

})